import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, PositionBottomEndTitle, PositionBottomStartTitle, PositionTopEndTitle, PositionTopStartTitle, SweetAlert } from "../../../Constants/Constants";
import { PositionBottomEndSubTitle, PositionBottomStartSubTitle, PositionTopEndSubTitle, PositionTopStartSubTitle } from "../../../Data/BonusUi/SweetAlert";
import BasicAlert from "./BasicAlert";
import DismissAlert from "./DismissAlert";
import PositionAlert from "./PositionAlert";
import RichHtmlAlert from "./RichHtmlAlert";
import TitleWithText from "./TitleWithText";
import ConfirmationAlert from "./ConfirmationAlert";
import AnimatedAlert from "./AnimatedAlert";
import ConfirmationWithTriggers from "./ConfirmationWithTriggers";
import ImageRichMessage from "./ImageRichMessage";
import AutoCloseTimer from "./AutoCloseTimer";
import AJAXRequestAlert from "./AJAXRequestAlert";
import ConfirmationWithApprovals from "./ConfirmationWithApprovals";
import ComprehensiveRTLSupport from "./ComprehensiveRTLSupport";
import PasswordGeneratorAlert from "./PasswordGeneratorAlert";
import DateAlert from "./DateAlert";
import CustomPositionedDialog from "./CustomPositionedDialog";
import RegistrationForm from "./RegistrationForm";

const SweetAlertContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={SweetAlert} parent={BonusUi} />
      <Container fluid>
        <Row>
          <PositionAlert position="top-start" color="secondary" title={PositionTopStartTitle} span={PositionTopStartSubTitle} />
          <PositionAlert position="top-end" color="success" title={PositionTopEndTitle} span={PositionTopEndSubTitle} />
          <PositionAlert position="bottom-start" color="warning" title={PositionBottomStartTitle} span={PositionBottomStartSubTitle} />
          <PositionAlert position="bottom-end" color="primary" title={PositionBottomEndTitle} span={PositionBottomEndSubTitle} />
          <BasicAlert />
          <TitleWithText />
          <DismissAlert />
          <RichHtmlAlert />
          <ConfirmationAlert />
          <AnimatedAlert />
          <ConfirmationWithTriggers />
          <ImageRichMessage />
          <AutoCloseTimer />
          <AJAXRequestAlert />
          <ConfirmationWithApprovals />
          <ComprehensiveRTLSupport />
          <PasswordGeneratorAlert />
          <DateAlert />
          <CustomPositionedDialog />
          <RegistrationForm />
        </Row>
      </Container>
    </Fragment>
  );
};

export default SweetAlertContainer;
